import type { SignInCodeChannel } from '@chukua/common';

/** How a sign-in code can reach the mobile on this deployment, from the channels the server says can send right now. */
export function phoneCodeChannelsLabel(channels: readonly SignInCodeChannel[]): string {
  const hasWhatsApp = channels.includes('whatsapp');
  const hasSms = channels.includes('sms');
  if (hasWhatsApp && hasSms) return 'By WhatsApp, or SMS';
  if (hasWhatsApp) return 'By WhatsApp';
  if (hasSms) return 'By SMS';
  return 'Phone codes are not set up here yet';
}
